import { createContext, useContext, useEffect, useMemo, useState } from "react";

const DICTIONARIES = {
  it: {
    nav: { home: "Home", studio: "Prova taglia", wardrobe: "Il tuo armadio", profile: "Profilo", settings: "Impostazioni", support: "Assistenza", analyze: "Analisi prodotto" },
    analyze: {
      kicker: "Nuovo",
      title: "Analisi Prodotto — Universale",
      subtitle: "Incolla un link e scopri la tua taglia perfetta su qualsiasi shop. Confrontiamo la tabella del brand con le tue misure salvate e ti diamo il consiglio in italiano chiaro.",
      urlLabel: "Incolla il link del prodotto",
      placeholder: "Amazon, Zara, H&M, Asos, Zalando — qualsiasi shop",
      cta: "Trova la mia taglia perfetta",
      working: "Analizzo…",
      screenshotLabel: "Non riesco a leggere la tabella",
      screenshotHint: "Alcuni siti bloccano la lettura automatica. Carica uno screenshot nitido della tabella taglie e penso io al resto.",
    },
    family: {
      label: "Profilo",
      title: "Profili famiglia",
      owner: "Titolare",
      add: "Aggiungi profilo",
      placeholder: "Nome (es. Giulia)",
      save: "Salva",
      rename: "Rinomina",
      full: "Hai raggiunto 4 profili",
      private: "Ogni profilo ha foto, misure e armadio separati e privati.",
      switched: "Profilo attivo:",
    },
    sub: {
      honeymoonBanner: "Primo mese tutto illimitato gratis. Poi 3 prove gratis ogni giorno, oppure PRO illimitato.",
      counter: "Ti restano {n} prove gratuite",
      counterZero: "Prove free esaurite — sblocca per continuare",
      honeymoonBadge: "Luna di miele · {n} giorni rimanenti",
      honeymoonUnlimited: "Illimitato gratis",
      current: "Piano attuale",
      pricing: {
        title: "1° MESE GRATIS illimitato",
        subtitle: "poi scegli:",
        freeNote: "Dopo il primo mese gratis illimitato, puoi continuare gratis con 5 prove al mese",
        freeKicker: "Free",
        freeTitle: "0 €",
        freeSub: "5 prove al mese",
        freeCta: "Continua gratis",
        footnote: "Pagamento unico, nessun rinnovo automatico. Prezzi IVA inclusa.",
        extraKicker: "Una tantum",
        extraTitle: "0,99 €",
        extraSub: "1 prova",
        extraCta: "Sblocca",
        singleKicker: "Single · 30 giorni",
        singleTitle: "2,99 €",
        singleSub: "Illimitato",
        singleCta: "Attiva PRO",
        familyKicker: "Family · 30 giorni",
        familyTitle: "4,99 €",
        familySub: "Fino a 4 utenti. 4 spazi foto, 4 misure separate. Solo per questo abbonamento.",
        familyCta: "Attiva Family",
        popular: "Più scelto",
        processing: "Apro Stripe…",
      },
      plans: {
        free: "Free",
        single: "PRO",
        family: "Family Illimitato",
      },
      paywall: {
        title: "Hai finito le 3 prove di oggi",
        subtitle: "Tornano domani a mezzanotte. Oppure continua subito:",
        close: "Chiudi",
        extraTitle: "BOOST · +3 prove oggi",
        extraPrice: "0,99 €",
        extraCta: "Attiva BOOST",
        extraNote: "3 prove extra valide solo oggi, fino a mezzanotte",
        singleTitle: "PRO · Illimitato",
        singlePrice: "2,99 € / 30 giorni",
        singleCta: "Passa a PRO",
        singlePerks: ["Prove illimitate ogni giorno", "Senza watermark: solo una firma discreta", "Salvataggio outfit illimitato", "Accesso anticipato ai nuovi brand", "Badge PRO oro"],
        familyTitle: "Family Illimitato",
        familyPrice: "4,99 €/mese",
        familyCta: "Attiva Family",
        familyPerks: ["Fino a 4 utenti", "4 spazi foto, 4 misure separate", "Solo per questo abbonamento"],
        popular: "Più scelto",
        processing: "Pagamento in corso…",
        success: "Pagamento confermato",
      },
      settings: {
        title: "Abbonamento",
        currentPlan: "Il tuo piano",
        memberSince: "Membro dal",
        thisMonth: "Prove usate oggi",
        extraCredits: "Prove bonus disponibili (non scadono)",
        upgrade: "Scegli un piano",
        cancel: "Torna al piano Free",
        confirmCancel: "Confermi di tornare al piano Free?",
      },
    },
    accuracy: {
      label: "Fitting Accuracy",
      reliable: "Affidabile",
      yes: "SÌ",
      no: "NO",
      tooltipTitle: "Attenzione",
      tooltipBody: "Profilo non affidabile per reso garantito. Completa misure e aggiorna il peso.",
      updateNow: "Aggiorna ora",
    },
    weight: {
      banner: "Controllo peso",
      stale: "Attenzione: Fit non affidabile — Aggiorna peso",
      due: "Aggiorna il tuo peso per mantenere il fit perfetto",
      start: "Registra il tuo peso per iniziare — ti avvisiamo noi quando ricontrollarlo",
      modalTitle: "Aggiorna il tuo peso",
      modalHint: "Serve per mantenere taglie accurate e profilo affidabile per i brand partner.",
      field: "Peso (kg)",
      save: "Salva",
      cancel: "Annulla",
      invalid: "Inserisci un peso valido in kg",
      saved: "Peso aggiornato!",
      serverError: "Salvataggio sul server non riuscito",
    },
    dashboard: {
      welcome: "Bentornato",
      hiAgain: "Benvenuto,",
      fallbackName: "amica",
      heroCopy: "Il tuo camerino è pronto. Avvia una nuova prova o rivedi un look salvato nel tuo atelier.",
      newTryOn: "Nuova prova",
      cards: {
        measurementsLabel: "Misurazioni",
        measurementsValue: "Le tue misure",
        measurementsCtaAdd: "Aggiungi",
        measurementsCtaUpdate: "Aggiorna",
        wardrobeLabel: "Il tuo armadio",
        wardrobeUnit: "capi",
        wardrobeCta: "Apri l'armadio",
        studioLabel: "Prova taglia",
        studioValue: "Pronta",
        studioCta: "Entra",
      },
      recent: "Prove recenti",
      atelier: "Il tuo atelier",
      seeAll: "Vedi tutto",
      emptyTitle: "Atelier vuoto",
      emptyBody: "Nessuna prova ancora. Vai allo Studio per vedere come ti sta il tuo prossimo capo preferito.",
      openStudio: "Apri lo Studio",
      untitled: "Senza titolo",
      piece: "capo",
    },
  },
  en: {
    nav: { home: "Home", studio: "Try size", wardrobe: "Your wardrobe", profile: "Profile", settings: "Settings", support: "Help", analyze: "Product analyzer" },
    analyze: {
      kicker: "New",
      title: "Product Analyzer — Universal",
      subtitle: "Paste a link and discover your perfect size in any shop. We compare the brand's chart with your saved measurements and give a clear recommendation.",
      urlLabel: "Paste the product link",
      placeholder: "Amazon, Zara, H&M, Asos, Zalando — any store",
      cta: "Find my perfect size",
      working: "Analyzing…",
      screenshotLabel: "Can't read the chart",
      screenshotHint: "Some sites block automatic reading. Upload a clear screenshot of the size chart and we'll handle the rest.",
    },
    family: {
      label: "Profile",
      title: "Family profiles",
      owner: "Owner",
      add: "Add profile",
      placeholder: "Name (e.g. Julia)",
      save: "Save",
      rename: "Rename",
      full: "You have reached 4 profiles",
      private: "Each profile has its own private photo, measurements and wardrobe.",
      switched: "Active profile:",
    },
    sub: {
      honeymoonBanner: "First month fully unlimited, free. From month two, you choose how to continue — 5 free try-ons/month always included.",
      counter: "{n} free try-ons left",
      counterZero: "Free try-ons used up — unlock to continue",
      honeymoonBadge: "Honeymoon · {n} days left",
      honeymoonUnlimited: "Unlimited, free",
      current: "Current plan",
      pricing: {
        title: "FIRST MONTH FREE unlimited",
        subtitle: "then choose:",
        freeNote: "After your first free unlimited month, you can keep going for free with 5 try-ons a month",
        freeKicker: "Free",
        freeTitle: "0 €",
        freeSub: "5 try-ons per month",
        freeCta: "Continue for free",
        footnote: "One-time payment, no auto-renewal. VAT included.",
        extraKicker: "One-off",
        extraTitle: "€0.99",
        extraSub: "1 try-on",
        extraCta: "Unlock",
        singleKicker: "Single · 30 days",
        singleTitle: "€2.99",
        singleSub: "Unlimited",
        singleCta: "Activate Single",
        familyKicker: "Family · 30 days",
        familyTitle: "€4.99",
        familySub: "Up to 4 users. 4 photo spaces, 4 separate measurements. Only with this plan.",
        familyCta: "Activate Family",
        popular: "Most chosen",
        processing: "Opening Stripe…",
      },
      plans: { free: "Free", single: "Single Unlimited", family: "Family Unlimited" },
      paywall: {
        title: "You've used your free try-ons",
        subtitle: "Pick how to continue. Cancel any time.",
        close: "Close",
        extraTitle: "+1 extra try-on",
        extraPrice: "€0.99",
        extraCta: "Unlock a try-on",
        extraNote: "A single try-on, usable right now",
        singleTitle: "Single Unlimited",
        singlePrice: "€2.99/mo",
        singleCta: "Activate Single",
        singlePerks: ["Unlimited try-ons", "3 saved wardrobes", "Size advice for every brand"],
        familyTitle: "Family Unlimited",
        familyPrice: "€4.99/mo",
        familyCta: "Activate Family",
        familyPerks: ["Up to 4 users", "4 photo spaces, 4 separate measurements", "Only with this plan"],
        popular: "Most chosen",
        processing: "Payment in progress…",
        success: "Payment confirmed",
      },
      settings: {
        title: "Subscription",
        currentPlan: "Your plan",
        memberSince: "Member since",
        thisMonth: "Try-ons used this month",
        extraCredits: "Extra try-ons available",
        upgrade: "Choose a plan",
        cancel: "Back to Free plan",
        confirmCancel: "Confirm downgrade to Free?",
      },
    },
    accuracy: {
      label: "Fitting Accuracy",
      reliable: "Reliable",
      yes: "YES",
      no: "NO",
      tooltipTitle: "Attention",
      tooltipBody: "Profile not reliable for guaranteed returns. Complete measurements and update your weight.",
      updateNow: "Update now",
    },
    weight: {
      banner: "Weight check",
      stale: "Warning: unreliable fit — Update your weight",
      due: "Update your weight to keep a perfect fit",
      start: "Record your weight to begin — we remind you when to check again",
      modalTitle: "Update your weight",
      modalHint: "Keeps sizes accurate and your profile reliable for partner brands.",
      field: "Weight (kg)",
      save: "Save",
      cancel: "Cancel",
      invalid: "Enter a valid weight in kg",
      saved: "Weight updated!",
      serverError: "Server save failed",
    },
    dashboard: {
      welcome: "Welcome back",
      hiAgain: "Welcome,",
      fallbackName: "friend",
      heroCopy: "Your fitting room is ready. Start a new try-on or revisit a saved look from your atelier.",
      newTryOn: "New try-on",
      cards: {
        measurementsLabel: "Measurements",
        measurementsValue: "Your sizes",
        measurementsCtaAdd: "Add",
        measurementsCtaUpdate: "Update",
        wardrobeLabel: "Your wardrobe",
        wardrobeUnit: "pieces",
        wardrobeCta: "Open the wardrobe",
        studioLabel: "Try size",
        studioValue: "Ready",
        studioCta: "Enter",
      },
      recent: "Recent try-ons",
      atelier: "Your atelier",
      seeAll: "See all",
      emptyTitle: "Empty atelier",
      emptyBody: "No try-ons yet. Head to the Studio to see how your next favourite piece will look on you.",
      openStudio: "Open the Studio",
      untitled: "Untitled",
      piece: "piece",
    },
  },
  fr: {
    nav: { home: "Accueil", studio: "Essayer taille", wardrobe: "Votre dressing", profile: "Profil", settings: "Réglages", analyze: "Analyse produit", support: "Assistance" },
    analyze: {
      kicker: "Nouveau",
      title: "Analyse Produit — Universelle",
      subtitle: "Collez un lien et trouvez votre taille parfaite dans n'importe quelle boutique. Nous comparons le guide des tailles à vos mesures et vous donnons un conseil clair.",
      urlLabel: "Collez le lien du produit",
      placeholder: "Amazon, Zara, H&M, Asos, Zalando — n'importe quel site",
      cta: "Trouver ma taille parfaite",
      working: "J'analyse…",
      screenshotLabel: "Je n'arrive pas à lire le guide",
      screenshotHint: "Certains sites bloquent la lecture automatique. Téléchargez une capture d'écran nette du guide des tailles.",
    },
    family: {
      label: "Profil",
      title: "Profils famille",
      owner: "Titulaire",
      add: "Ajouter un profil",
      placeholder: "Prénom (ex. Julie)",
      save: "Enregistrer",
      rename: "Renommer",
      full: "Vous avez atteint 4 profils",
      private: "Chaque profil a sa photo, ses mesures et son dressing, séparés et privés.",
      switched: "Profil actif :",
    },
    sub: {
      honeymoonBanner: "Premier mois entièrement illimité, gratuit. Dès le mois 2, vous choisissez — 5 essayages gratuits/mois toujours inclus.",
      counter: "Il vous reste {n} essayages gratuits",
      counterZero: "Essayages gratuits épuisés — débloquez pour continuer",
      honeymoonBadge: "Lune de miel · {n} jours restants",
      honeymoonUnlimited: "Illimité, gratuit",
      current: "Formule actuelle",
      pricing: {
        title: "1er MOIS GRATUIT illimité",
        subtitle: "puis choisissez :",
        freeNote: "Après le premier mois gratuit illimité, continuez gratuitement avec 5 essayages par mois",
        freeKicker: "Free",
        freeTitle: "0 €",
        freeSub: "5 essayages par mois",
        freeCta: "Continuer gratuitement",
        footnote: "Paiement unique, sans renouvellement automatique. TVA incluse.",
        extraKicker: "Une fois",
        extraTitle: "0,99 €",
        extraSub: "1 essayage",
        extraCta: "Débloquer",
        singleKicker: "Single · 30 jours",
        singleTitle: "2,99 €",
        singleSub: "Illimité",
        singleCta: "Activer Single",
        familyKicker: "Family · 30 jours",
        familyTitle: "4,99 €",
        familySub: "Jusqu'à 4 utilisateurs. 4 espaces photo, 4 mesures séparées. Uniquement avec cet abonnement.",
        familyCta: "Activer Family",
        popular: "Le plus choisi",
        processing: "Ouverture Stripe…",
      },
      plans: { free: "Free", single: "Single Illimité", family: "Family Illimité" },
      paywall: {
        title: "Vos essayages gratuits sont épuisés",
        subtitle: "Choisissez comment continuer. Résiliable à tout moment.",
        close: "Fermer",
        extraTitle: "+1 essayage",
        extraPrice: "0,99 €",
        extraCta: "Débloquer un essayage",
        extraNote: "Un seul essayage, utilisable immédiatement",
        singleTitle: "Single Illimité",
        singlePrice: "2,99 €/mois",
        singleCta: "Activer Single",
        singlePerks: ["Essayages illimités", "3 dressings sauvegardés", "Taille conseillée pour chaque marque"],
        familyTitle: "Family Illimité",
        familyPrice: "4,99 €/mois",
        familyCta: "Activer Family",
        familyPerks: ["Jusqu'à 4 utilisateurs", "4 espaces photo, 4 mesures séparées", "Uniquement avec cet abonnement"],
        popular: "Le plus choisi",
        processing: "Paiement en cours…",
        success: "Paiement confirmé",
      },
      settings: {
        title: "Abonnement",
        currentPlan: "Votre formule",
        memberSince: "Membre depuis",
        thisMonth: "Essayages ce mois-ci",
        extraCredits: "Essayages extra disponibles",
        upgrade: "Choisir une formule",
        cancel: "Revenir en Free",
        confirmCancel: "Confirmer le retour à Free ?",
      },
    },
    accuracy: {
      label: "Fitting Accuracy",
      reliable: "Fiable",
      yes: "OUI",
      no: "NON",
      tooltipTitle: "Attention",
      tooltipBody: "Profil non fiable pour un retour garanti. Complétez vos mesures et mettez à jour votre poids.",
      updateNow: "Mettre à jour",
    },
    weight: {
      banner: "Contrôle du poids",
      stale: "Attention : coupe non fiable — Mettez à jour votre poids",
      due: "Mettez à jour votre poids pour un ajustement parfait",
      start: "Enregistrez votre poids pour commencer — nous vous rappelons quand le vérifier",
      modalTitle: "Mettre à jour votre poids",
      modalHint: "Garde les tailles précises et le profil fiable pour les marques partenaires.",
      field: "Poids (kg)",
      save: "Enregistrer",
      cancel: "Annuler",
      invalid: "Entrez un poids valide en kg",
      saved: "Poids mis à jour !",
      serverError: "Échec de l'enregistrement sur le serveur",
    },
    dashboard: {
      welcome: "Bon retour",
      hiAgain: "Bienvenue,",
      fallbackName: "ami·e",
      heroCopy: "Votre cabine d'essayage est prête. Lancez un nouvel essayage ou revisitez un look sauvegardé.",
      newTryOn: "Nouvel essayage",
      cards: {
        measurementsLabel: "Mesures",
        measurementsValue: "Vos tailles",
        measurementsCtaAdd: "Ajouter",
        measurementsCtaUpdate: "Mettre à jour",
        wardrobeLabel: "Votre dressing",
        wardrobeUnit: "pièces",
        wardrobeCta: "Ouvrir le dressing",
        studioLabel: "Essayer taille",
        studioValue: "Prêt",
        studioCta: "Entrer",
      },
      recent: "Essayages récents",
      atelier: "Votre atelier",
      seeAll: "Tout voir",
      emptyTitle: "Atelier vide",
      emptyBody: "Aucun essayage. Allez au Studio pour voir votre prochaine pièce préférée.",
      openStudio: "Ouvrir le Studio",
      untitled: "Sans titre",
      piece: "pièce",
    },
  },
  de: {
    nav: { home: "Start", studio: "Größe testen", wardrobe: "Dein Kleiderschrank", profile: "Profil", settings: "Einstellungen", analyze: "Produktanalyse", support: "Hilfe" },
    analyze: {
      kicker: "Neu",
      title: "Produktanalyse — Universal",
      subtitle: "Füge einen Link ein und finde deine perfekte Größe in jedem Shop. Wir vergleichen die Größentabelle mit deinen Maßen und geben eine klare Empfehlung.",
      urlLabel: "Füge den Produktlink ein",
      placeholder: "Amazon, Zara, H&M, Asos, Zalando — jeder Shop",
      cta: "Meine perfekte Größe finden",
      working: "Analysiere…",
      screenshotLabel: "Tabelle nicht lesbar",
      screenshotHint: "Manche Seiten blockieren das automatische Lesen. Lade einen klaren Screenshot der Größentabelle hoch.",
    },
    family: {
      label: "Profil",
      title: "Familienprofile",
      owner: "Inhaber",
      add: "Profil hinzufügen",
      placeholder: "Name (z. B. Julia)",
      save: "Speichern",
      rename: "Umbenennen",
      full: "Du hast 4 Profile erreicht",
      private: "Jedes Profil hat eigenes Foto, eigene Maße und Garderobe – getrennt und privat.",
      switched: "Aktives Profil:",
    },
    sub: {
      honeymoonBanner: "Erster Monat komplett unbegrenzt, gratis. Ab dem zweiten Monat entscheidest du — 5 kostenlose Try-ons/Monat immer inklusive.",
      counter: "Du hast noch {n} kostenlose Try-ons",
      counterZero: "Kostenlose Try-ons aufgebraucht — jetzt freischalten",
      honeymoonBadge: "Honeymoon · {n} Tage übrig",
      honeymoonUnlimited: "Unbegrenzt, gratis",
      current: "Aktueller Plan",
      pricing: {
        title: "1. MONAT GRATIS unbegrenzt",
        subtitle: "danach wähle:",
        freeNote: "Nach dem ersten kostenlosen unbegrenzten Monat kannst du kostenlos mit 5 Anproben pro Monat weitermachen",
        freeKicker: "Free",
        freeTitle: "0 €",
        freeSub: "5 Anproben pro Monat",
        freeCta: "Kostenlos weiter",
        footnote: "Einmalzahlung, keine automatische Verlängerung. Inkl. MwSt.",
        extraKicker: "Einmalig",
        extraTitle: "0,99 €",
        extraSub: "1 Try-on",
        extraCta: "Freischalten",
        singleKicker: "Single · 30 Tage",
        singleTitle: "2,99 €",
        singleSub: "Unbegrenzt",
        singleCta: "Single aktivieren",
        familyKicker: "Family · 30 Tage",
        familyTitle: "4,99 €",
        familySub: "Bis zu 4 Nutzer. 4 Fotobereiche, 4 getrennte Maße. Nur mit diesem Abo.",
        familyCta: "Family aktivieren",
        popular: "Beliebteste Wahl",
        processing: "Stripe wird geöffnet…",
      },
      plans: { free: "Free", single: "Single Unlimited", family: "Family Unlimited" },
      paywall: {
        title: "Deine kostenlosen Try-ons sind aufgebraucht",
        subtitle: "Wähle, wie du weitermachst. Jederzeit kündbar.",
        close: "Schließen",
        extraTitle: "+1 Try-on",
        extraPrice: "0,99 €",
        extraCta: "Try-on freischalten",
        extraNote: "Ein einzelnes Try-on, sofort nutzbar",
        singleTitle: "Single Unlimited",
        singlePrice: "2,99 €/Monat",
        singleCta: "Single aktivieren",
        singlePerks: ["Unbegrenzte Try-ons", "3 gespeicherte Garderoben", "Größenempfehlung für jede Marke"],
        familyTitle: "Family Unlimited",
        familyPrice: "4,99 €/Monat",
        familyCta: "Family aktivieren",
        familyPerks: ["Bis zu 4 Nutzer", "4 Fotobereiche, 4 getrennte Maße", "Nur mit diesem Abo"],
        popular: "Beliebteste Wahl",
        processing: "Zahlung läuft…",
        success: "Zahlung bestätigt",
      },
      settings: {
        title: "Abonnement",
        currentPlan: "Dein Plan",
        memberSince: "Mitglied seit",
        thisMonth: "Try-ons diesen Monat",
        extraCredits: "Verfügbare Extra-Try-ons",
        upgrade: "Plan wählen",
        cancel: "Zurück zu Free",
        confirmCancel: "Downgrade zu Free bestätigen?",
      },
    },
    accuracy: {
      label: "Fitting Accuracy",
      reliable: "Zuverlässig",
      yes: "JA",
      no: "NEIN",
      tooltipTitle: "Achtung",
      tooltipBody: "Profil nicht zuverlässig für garantierte Rücksendung. Maße vervollständigen und Gewicht aktualisieren.",
      updateNow: "Jetzt aktualisieren",
    },
    weight: {
      banner: "Gewichtskontrolle",
      stale: "Achtung: Passform unzuverlässig — Gewicht aktualisieren",
      due: "Gewicht aktualisieren, damit die Passform perfekt bleibt",
      start: "Dein Gewicht erfassen — wir erinnern dich ans Prüfen",
      modalTitle: "Gewicht aktualisieren",
      modalHint: "Für präzise Größen und ein zuverlässiges Profil bei Partnermarken.",
      field: "Gewicht (kg)",
      save: "Speichern",
      cancel: "Abbrechen",
      invalid: "Gib ein gültiges Gewicht in kg ein",
      saved: "Gewicht aktualisiert!",
      serverError: "Speichern auf dem Server fehlgeschlagen",
    },
    dashboard: {
      welcome: "Willkommen zurück",
      hiAgain: "Willkommen,",
      fallbackName: "Freund·in",
      heroCopy: "Deine Umkleide ist bereit. Starte ein neues Try-on oder öffne einen gespeicherten Look.",
      newTryOn: "Neues Try-on",
      cards: {
        measurementsLabel: "Maße",
        measurementsValue: "Deine Größen",
        measurementsCtaAdd: "Hinzufügen",
        measurementsCtaUpdate: "Aktualisieren",
        wardrobeLabel: "Dein Kleiderschrank",
        wardrobeUnit: "Teile",
        wardrobeCta: "Kleiderschrank öffnen",
        studioLabel: "Größe testen",
        studioValue: "Bereit",
        studioCta: "Eintreten",
      },
      recent: "Letzte Try-ons",
      atelier: "Dein Atelier",
      seeAll: "Alle ansehen",
      emptyTitle: "Atelier leer",
      emptyBody: "Noch keine Try-ons. Geh zum Studio, um dein nächstes Lieblingsstück zu sehen.",
      openStudio: "Studio öffnen",
      untitled: "Ohne Titel",
      piece: "Teil",
    },
  },
};

export const LANGS = [
  { code: "it", label: "IT", flag: "🇮🇹" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "fr", label: "FR", flag: "🇫🇷" },
  { code: "de", label: "DE", flag: "🇩🇪" },
];

const I18nCtx = createContext({ lang: "it", setLang: () => {}, t: (p) => p });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("vfit_lang") || "it"; } catch { return "it"; }
  });

  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem("vfit_lang", l); } catch (_e) { /* ignore */ }
  };

  useEffect(() => {
    const el = document.documentElement;
    el.setAttribute("lang", lang);
    el.setAttribute("translate", "no");
    el.classList.add("notranslate");
    document.body?.setAttribute("translate", "no");
    document.body?.classList.add("notranslate");
  }, [lang]);

  const t = useMemo(() => {
    const dict = DICTIONARIES[lang] || DICTIONARIES.it;
    return (path) => {
      const parts = path.split(".");
      let node = dict;
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else return path;
      }
      return node;
    };
  }, [lang]);

  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
